<template>
    <div class="modal-mask">
        <a  class="modal-default-button" @click="servicesModalClose() ">
            <img src="../assets/images/modal/close.svg" alt="CiBeez"/>
        </a>
        <div data-aos="fade" data-aos-duration="3000"  class="modal-wrapper container">
            <div class="modal-container row">
                <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                    <h3 class="title-modal">Why Should You Have A Multi-Carrier Strategy Implemented With Cibeez?</h3>
                    <p class="font_7">
                        <span>
                            Delivery services and customer expectations are rapidly changing. Leveraging different options as part of a multi-carrier delivery strategy is critical to maintaining your competitive advantage:
                        </span>
                    </p>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                    <ul class="modal-list">
                        <li>Provide superior service and customer experience</li>
                        <li>Balance supply and demand in real-time and resolve peak-time challenges </li>
                        <li>Provide the best delivery option from multiple-carriers with automatic carrier allocation</li>
                        <li>Achieve high level of operational efficiency and reduce costs</li>
                        <li>Launching speedy delivery is an increasingly high-stakes battleground for retailers</li>
                        <li>Utilize an efficient e-commerce delivery network</li>
                        <li>Launch your own delivery service within days to provide customized delivery service</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        methods: {
            servicesModalClose() {
                this.$emit('servicesClose')
            }
        }
    }
</script>
